import { render } from "./MenuSide.vue?vue&type=template&id=11a870e5"
import script from "./MenuSide.vue?vue&type=script&lang=js"
export * from "./MenuSide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__